module.exports = __webpack_public_path__ + "static/media/top-img_2@2x.f200fc15.png";